(function(){
 'use strict';
 const api=window.ManiaOrder;
 const originalLinks=new Map();
 if(!api)return;
 function selectedSize(){return typeof size==='string'?size:'';}
 function activeProduct(){return typeof current!=='undefined'&&current&&!document.querySelector('#product-view')?.hidden?current:null;}
 function update(p){
  if(!p)return;
  api.preparePhotos([{id:p.id,product:p}]);
  const heading=document.querySelector('#product-view .size-heading');
  if(heading&&!document.querySelector('.ref-missing-size')){
   const link=document.createElement('a');link.className='ref-missing-size';link.textContent='Non trovi la taglia?';heading.after(link);
  }
  document.querySelectorAll('.ref-missing-size,[data-stock-help],.sg-help,.floating-wa,a[href*="wa.me/393274698749"]').forEach(link=>{
   if(link.closest('#order-share-dialog,.bag-dialog'))return;
   if(!originalLinks.has(link))originalLinks.set(link,link.getAttribute('href'));
   const kind=link.matches('.ref-missing-size,.sg-help')?'size':link.matches('[data-stock-help]')?'stock':'product';
   link.href='https://wa.me/393274698749?text='+encodeURIComponent(api.inquiryMessage({product:p,size:selectedSize(),kind}));
  });
 }
 const renderBeforeContact=renderProduct;
 renderProduct=function(p){renderBeforeContact(p);update(p);};
 document.addEventListener('click',e=>{
  const link=e.target.closest('.ref-missing-size,[data-stock-help],.sg-help,.floating-wa,a[href*="wa.me/393274698749"],.missing-gallery a');
  const p=activeProduct();
  if(!link||!p||link.closest('#order-share-dialog,.bag-dialog'))return;
  e.preventDefault();
  const kind=link.matches('.ref-missing-size,.sg-help')?'size':link.matches('[data-stock-help]')?'stock':'product';
  document.querySelector('#size-dialog[open]')?.close();
  api.inquire({product:p,size:selectedSize(),kind});
 });
 const guideBeforeContact=showSizeGuide;
 showSizeGuide=function(){guideBeforeContact();update(activeProduct());};
 window.addEventListener('hashchange',()=>{if(activeProduct())return;originalLinks.forEach((href,link)=>{if(!link.isConnected){originalLinks.delete(link);return;}if(href===null)link.removeAttribute('href');else link.setAttribute('href',href);});});
 update(activeProduct());
})();
